<div
  *ngIf="form"
  class="mb-1 flex w-full gap-2"
  [class]="styleClass"
  [ngClass]="{
    'flex-col': direction === 'col',
    'flex-row': direction === 'row',
    'justify-center': direction === 'col',
    'items-center': direction === 'row'
  }"
>
  <label
    [class]="'relative ' + labelClass"
    [for]="name"
    [ngClass]="{
      'text-right': direction === 'row',
      'top-[-8px]': direction === 'row'
    }"
  >
    {{ label }}
  </label>
  <div [ngClass]="{ 'w-full': direction === 'col' }">
    <ng-container [formGroup]="form">
      <span class="p-input-icon-right w-full">
        <i class="pi pi-spin pi-spinner h-full">
          <p-progressSpinner *ngIf="loading" styleClass="h-[1.5rem] w-[1.5rem]" strokeWidth="4" />
        </i>
        <input
          pInputText
          [type]="type"
          [mask]="mask"
          [class]="'w-full min-w-[150px] ' + widthClass + ' ' + styleClass"
          [required]="required"
          [id]="name"
          [formControlName]="name"
          [placeholder]="placeholder"
          [name]="name"
          [ngClass]="
            required && name && form && form.controls[name].invalid && form.controls[name].touched
              ? 'ng-invalid ng-dirty'
              : ''
          "
          (keydown)="keydown($event)"
          (focus)="emitOnFocus && whenFocused.emit(name.toString())"
        />
      </span>
    </ng-container>
    <div class="relative min-h-[1.75rem]">
      <small
        *ngIf="name && form && form.controls[name].invalid && form.controls[name].touched"
        class="p-error"
      >
        {{ errors }}
      </small>
    </div>
  </div>
</div>
